import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/landing-page/components/LandingPageInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageProvider"] */ "/vercel/path0/src/contexts/LanguageContext.tsx");
